import { render, staticRenderFns } from "./PayeeInfoPreview.vue?vue&type=template&id=5b77446d&scoped=true&"
import script from "./PayeeInfoPreview.vue?vue&type=script&lang=ts&"
export * from "./PayeeInfoPreview.vue?vue&type=script&lang=ts&"
import style0 from "./PayeeInfoPreview.vue?vue&type=style&index=0&id=5b77446d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b77446d",
  null
  
)

export default component.exports